module.exports = __webpack_public_path__ + "static/media/icon.4d1dcba1.png";